import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Hero from "./components/Hero";

function App() {
  return (
    <div>
      <Hero />
    </div>
  );
}

export default App;
